import React, { useEffect } from 'react'
import '../App.css'
import isAuthenticated from '../utils/auth'
import { Redirect } from 'react-router-dom'
import ListFiles from '../components/files/display/ListFiles'
import Header from '../components/header/Header'
import BreadCrumbs from '../components/shared/BreadCrumbs'
import { Container } from 'semantic-ui-react'
import { observer, useStore } from '../stores'
import Uploads from '../components/files/Uploads'
export interface FileExplorerProps {
  location: any
}

const FileExplorer = observer((props: FileExplorerProps) => {
  const { uiStore } = useStore()
  useEffect(() => {
    uiStore.loadDefaultLayout()
  }, [uiStore])

  const { dropZoneDrop, dropZoneEnter, dropZoneLeave } = uiStore
  const { location } = props

  return isAuthenticated() ? (
    <div
      onDragEnter={dropZoneEnter}
      onDrop={dropZoneDrop}
      onDragLeave={dropZoneLeave}
    >
      <Container>
        <Header />
        <Uploads />
        <br />
        <br />
        {/* <ViewLayoutToggle /> */}
        <br />
        <br />
        <BreadCrumbs size="large" />
        <br />
        <ListFiles />
        <br />
        <br />
        <br />
        <br />
        {/* <FileViewer/> */}
      </Container>
      {/* <ActivityFeed /> */}
    </div>
  ) : (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: location },
      }}
    />
  )
})

export default FileExplorer
